// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SubmitClaimResultModelResponse {
    static getAttributeTypeMap() {
        return SubmitClaimResultModelResponse.attributeTypeMap;
    }
}
SubmitClaimResultModelResponse.discriminator = undefined;
SubmitClaimResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "SubmitClaimResultModel"
    }
];
//# sourceMappingURL=submitClaimResultModelResponse.js.map